/* eslint-disable no-console */
// Universal Analytics (react-ga / UA-7109444-5) removed — UA stopped processing
// data in July 2023. Basic tracking is handled by the GTM container (GTM-P34TJQR,
// loaded in public/index.html). Custom events are forwarded to GTM via the
// dataLayer so the data team can map them to GA4 if wanted; otherwise inert.
// (B2BY-4466)

class Tracker {
  push = payload => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  };

  trackEvent = (action, label, value) => {
    this.push({ event: 'radar_event', category: 'CareerChoiceRadar', action, label, value });
  };

  trackPageView = (route, action) => {
    this.push({
      event: 'radar_pageview',
      category: 'CareerChoiceRadar',
      action,
      page_path: `/berufswahlradar${route}`,
    });
  };
}

class DevTracker {
  constructor() {
    console.log('Spinning up dev tracker');
  }

  trackEvent = (action, label) => {
    console.log('tracking action', action, 'with label', label);
  };

  trackPageView = (route, action) => {
    console.log('tracking pageview on route', route, 'with action', action);
  };
}

const radarTracker = process.env.NODE_ENV === 'production' ? new Tracker() : new DevTracker();

export default radarTracker;
